import { isTabletPortraitDown } from '@enter/core';
import { Location } from 'history';
import _ from 'lodash';
import React from 'react';
import { match, Route, RouteProps, Switch } from 'react-router-dom';
import { RootStore } from 'stores';

export interface ISettingsPage {
    rootStore?: RootStore;
    children?: React.ReactNode;
}

// return a function that performs normal matching, but fails over to path comparison
export const isActiveFor = (...paths: string[]): ((m: match<any>, loc: Location<any>) => boolean) => {
    return (m: match<any>, loc: Location<any>): boolean => {
        const url = _.get(m, 'url');
        const pathname = _.get(loc, 'pathname');
        return url === pathname || (!isTabletPortraitDown && _.includes(paths, pathname));
    };
};

// return a Switch to handle the provided routes, with support for parent paths base on first route
// ex: for [ /cat/sub/a, /cat/sub/b ], generate a switch that handles
// [ /cat/sub/a, /cat/sub/b, /cat/sub, /cat ], where root routes are aliases for the first route
export const switchForRoutes = (routes: RouteProps[]): React.ReactElement => {
    if (!_.isEmpty(routes)) {
        const itemPaths = _.map(routes, (route: RouteProps, i: number) => {
            return <Route key={`route-${i}`} path={route.path} component={route.component} />;
        });
        const basepaths = (path: string | string[] | undefined): string[] => {
            if (_.isUndefined(path)) {
                throw new Error(`Route path is required for use with switchForRoutes: ${routes[0]}`);
            }
            if (_.isArray(path)) {
                throw new Error(`Route path arrays are not supported for use with switchForRoutes: ${routes[0]}`);
            }
            // return each basepath (/a/b/c => [/a, /a/b])
            const segments = _.initial(_.split(path as string, '/'));
            const paths = _.times(_.size(segments), i => _.take(segments, i + 1).join('/'));
            return _.compact(paths);
        };
        const basePaths = _.map(basepaths(routes[0].path), path => (
            <Route key={path} path={path} component={routes[0].component} exact={true} />
        ));
        return (
            <Switch>
                {itemPaths}
                {basePaths}
            </Switch>
        );
    }
    return <></>;
};
